const findFirstOptionValue = (options) => {
  if (!Array.isArray(options) || options.length <= 0) {
    return;
  }

  const line = options[0];
  if (!line) {
    return;
  }
  let { label, value } = line;
  if (typeof line === "string") {
    label = line;
    value = line;
  }
  return value ? value : label;
};

export default findFirstOptionValue;
